import { Component, OnInit } from '@angular/core';
import { faHome, faPhone, faGlobe } from '@fortawesome/free-solid-svg-icons';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
public faHome = faHome;
public faPhone = faPhone;
public faGlobe = faGlobe;
  constructor() { }

  ngOnInit(): void {
  }

}
